import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ShepherdTour } from 'react-shepherd'
import {
  options as shepherdOptions,
  steps as shepherdSteps
} from '../assets/shepherd'
import PostHogPageviewTracker from '../PostHogPageviewTracker'
import { useLGDetection } from '../components/LG/hooks/useLGDetection'

function GlobalProviders({ children }) {
  const { isLGSmartTV } = useLGDetection()

  let GalleryJoyride = null
  try {
    GalleryJoyride = require('../components/Tours/GalleryJoyride').default
  } catch (e) {
    GalleryJoyride = null
  }

  // Disable Joyride on mobile sizes and LG TVs
  const shouldRenderJoyrides = !isLGSmartTV

  return (
    <ShepherdTour steps={shepherdSteps} tourOptions={shepherdOptions}>
      <Router>
        <PostHogPageviewTracker />
        <ToastContainer />
        {shouldRenderJoyrides && GalleryJoyride ? <GalleryJoyride /> : null}
        {children}
      </Router>
    </ShepherdTour>
  )
}

export default GlobalProviders